import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';

const WheelchairInfoModalContent = () => (
  <>
    <Typography variant="paragraph200">
      <FormattedMessage
        values={{ p: (...chunks: ReactNode[]) => <p>{chunks}</p> }}
        defaultMessage="<p>This rating is based on trail width, grade, cross-slopes, obstacles, surface firmness and type. Wheelchair friendly does not mean a trail is certified to be compliant with all country-specific accessibility legal standards.</p><p>Note that trail conditions can vary depending on time, weather and other events. Consider user skill and equipment type when choosing your trail.</p>"
      />
    </Typography>
  </>
);

export default WheelchairInfoModalContent;
